import { curry2 } from './curry2';
import { findMatches } from './findMatches';
export var select =
/*@__PURE__*/
curry2(findMatches);
export { selectorParser } from './selectorParser';
export { classNameFromVNode } from './classNameFromVNode';